import { Link } from "react-router-dom";
import database from "../data/database.json";
import CardMusic from "./CardMusic";
import { saveScrollCardPosition } from "../helpers";
import useWindowWidth from "../helpers";

const Card = ({ cardData }) => {
  const width = useWindowWidth();
  const isMobile = width < 480;

  if (cardData.id === "listen") {
    /**
     * condition for responsive design
     * if view/width is mobile
     *  then return card with specific card
     *  else return card-listener-wrapper as below
     */

    /* return listener card for mobile, (with same look&feel that pocaster and streamer cards) */
    if (isMobile) {
      return (
        <div className="card">
          <Link
            to={`/user/${cardData.id}`}
            key={cardData.key}
            onClick={saveScrollCardPosition}
          >
            <div className="card__overlay"></div>
            <img
              loading="lazy"
              src={cardData.src}
              srcSet={cardData.srcSet}
              sizes={cardData.sizes}
              alt={cardData.altImg}
            />
            <div className="card__headline">
              <p className="card__headline__title">{cardData.text}</p>
              <p className="card__headline__link">Learn more</p>
            </div>
          </Link>
        </div>
      );
    }

    return (
      <div className="card-listener-wrapper">
        <Link
          to={`/user/${cardData.id}`}
          key={cardData.key}
          className="card-listener"
          onClick={saveScrollCardPosition}
        >
          <div className="card-listener__heading">
            <p className="card-listener__heading__title">{cardData.text}</p>
            <p className="card-listener__heading__link">Learn more</p>
          </div>

          <div className="cards-music-wrapper">
            {Object.entries(database.musicCards).map(([index, data]) => (
              <CardMusic key={index} cardData={data} />
            ))}
          </div>
        </Link>
      </div>
    );
  }

  return (
    <div className="card">
      <Link
        to={`/user/${cardData.id}`}
        key={cardData.key}
        onClick={saveScrollCardPosition}
      >
        <div className="card__overlay"></div>
        <picture>
          {cardData.sources.map((source, idx) => {
            return (
              <source
                key={idx}
                media={source.media}
                sizes={source.sizes}
                srcSet={source.srcSet
                  .map((item) => `${item.src} ${item.width}`)
                  .join(", ")}
              />
            );
          })}

          <img src={cardData.fallback} alt={cardData.altImg} />
        </picture>

        <div className="card__headline">
          <p className="card__headline__title">{cardData.text}</p>
          <p className="card__headline__link">Learn more</p>
        </div>
      </Link>
    </div>
  );
};

export default Card;
